import { Text, Box } from "@vinomofo/components";
import { COLORS } from "../../styles";
import { Testimonial } from "./TestimonialCarousel";
import { Rating } from "./Rating";
import styled from "styled-components";

interface TestimonialCardProps {
  testimonial: Testimonial;
}

const getJoinedDate = (dateString: string): string => {
  const date = new Date(dateString);
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  return `Joined ${month}, ${year}`;
};

const ReviewCard = styled(Box)`
  padding: 50px 40px 30px;
  border-radius: 12px;
  background-color: #181717;
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;

  @media ${({ theme }) => theme.mq.max.mobile} {
    padding: 25px 25px 20px;
  }

  &:hover {
    border-color: ${COLORS.liquidGold};
    box-shadow: 0 10px 50px rgba(255, 255, 255, 0.1);
  }
`;

const ImageWrapper = styled(Box)`
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
`;

const CardContent = styled(Box)`
  flex: 1;
  width: 100%;
  margin-top: 30px;
`;

const CardFooter = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: auto;
  width: 100%;
  padding-top: 10px;
`;

const Avatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ReviewerInfo = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const TestimonialCard = ({ testimonial }: TestimonialCardProps) => {
  const { text, author, date, avatar, score } = testimonial;
  const formattedDate = getJoinedDate(date);

  return (
    <ReviewCard>
      <ImageWrapper>
        {avatar && <Avatar src={avatar} alt={author} />}
      </ImageWrapper>
      <CardContent>
        <Box style={{ marginBottom: 16 }}>
          <Box style={{ minHeight: 30 }}>
            {score && <Rating score={score} color="#FBC44E" size="32px" />}
          </Box>
          <Text
            as="h3"
            fontFamily={"heading"}
            fontSize={["16px", "18px"]}
            fontWeight="bold"
            color="white"
          >
            {text}
          </Text>
        </Box>
      </CardContent>

      <CardFooter>
        <ReviewerInfo>
          <Box>
            <Text
              fontFamily={"heading"}
              fontSize="15px"
              color="white"
              fontWeight="normal"
            >
              {author}
            </Text>
            <Text fontFamily={"heading"} fontSize="14px" color="dorianGray">
              {formattedDate}
            </Text>
          </Box>
        </ReviewerInfo>
      </CardFooter>
    </ReviewCard>
  );
};
